import { render, staticRenderFns } from "./SongListView.vue?vue&type=template&id=dadcd0b4&"
import script from "./SongListView.ts?vue&type=script&lang=js&"
export * from "./SongListView.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports